// Course data for "Basics of Python + AI + Robotics for Kids"
// This data is used by the AddPythonCourse component

export const pythonCourseData = {
  title: '🐍 Basics of Python + AI + Robotics for Kids',
  description: 'A fun and interactive course introducing kids to coding with Python, artificial intelligence, and robotics! 🚀✨',
  topics: [
    {
      name: '📚 1: Introduction to Coding, Python & Logic',
      description: `🎯 What is coding? Why Python?
✨ Basic computer logic (inputs, outputs, variables)
💻 Installing Python / Using online editors (Trinket, Replit)
🎉 First program: print("Hello World")
🎨 Fun mini-project: Name Printing App`,
      hours: 2
    },
    {
      name: '📚 2: Python Basics - Variables, Data Types & Input',
      description: `🔢 Numbers, strings, booleans
⌨️ input() for user interaction
➕ Basic operations (+, -, *, /)
🧮 Project: Interactive Calculator for Kids`,
      hours: 2
    },
    {
      name: '✅ 3: Conditions & Decision Making',
      description: `🔀 if / elif / else
⚖️ Comparison operators
🧠 Logical conditions
🎲 Project: Guess the Number Game`,
      hours: 2
    },
    {
      name: '✅ 4: Loops Made Fun',
      description: `🔄 for loop
🔁 while loop
📊 range()
✖️ Project: Multiplication Quiz Generator`,
      hours: 2
    },
    {
      name: '✅ 5: Functions & Modular Thinking',
      description: `⚙️ Making functions
♻️ Why reuse code?
📥 Passing values into functions
📖 Project: Emoji Story Creator using Functions`,
      hours: 2
    },
    {
      name: '🟣 6: What is AI? Machine Learning for Kids',
      description: `🤖 What is Artificial Intelligence?
🌐 Real-life examples (Alexa, YouTube suggestions)
📚 How machines learn
🎓 Simple ML demo using Teachable Machine
🎯 Project: Train a model to recognize objects (hands, poses, emojis)`,
      hours: 3
    },
    {
      name: '📚 7: Python for AI (Beginner Level)',
      description: `📋 Lists & loops review
🤖 Using basic AI libraries (no installation — online environment)
📊 Understanding datasets
😊 Project: Build a simple Emotion Classifier using Teachable Machine output`,
      hours: 3
    },
    {
      name: '🔧 8: Introduction to Robotics Concepts',
      description: `🤖 What is a robot?
🔌 Sensors, motors, controllers
🐍 Python-controlled robots (micro:bit / Raspberry Pi / LEGO Spike)
🖥️ Project: Simulated Robot Movement on Screen`,
      hours: 3
    },
    {
      name: '🔧 9: Python for Robotics',
      description: `⚙️ Motor control concepts
📡 Sensor input concepts
📝 Writing command sequences
🤖 Project: Build a virtual line-following robot simulation`,
      hours: 3
    },
    {
      name: '🎉 10: Final Project',
      description: `🎯 Kids pick one:
🎮 Python: A mini game (Rock-Paper-Scissors / Quiz game)
🖼️ AI: Image classifier project
🤖 Robotics: Robot movement simulator with obstacles`,
      hours: 4
    }
  ]
};

